
import React, { useEffect, useState } from "react";
import { Form, Input, DatePicker, Checkbox, Row, Col } from "antd";
import { LABELS, MESSAGES, DATE_FORMAT } from "../../util/Constants";
import { useDispatch, useSelector } from "react-redux";
import { setFormField } from "../../redux/slices/presurveySlice";
import {
  validateEndDate,
  validateStartDate,
  disableDateRange,
} from "../../util/DateUtils";
import "./PreSurvey.css";
import ToggleButton from "../../components/common/ToggleButton/ToggleButton";
import dayjs from "dayjs";
import { fetchPresurveyData } from "../../services/PreSurveyService";

const PreSurvey = ({
  form,
  handleFieldChange,
  handleDateChange,
  setIsDraft,
}) => {
  
      
  const [setPillars] = useState([]);
  const dispatch = useDispatch();
  const { supplierInfo } = useSelector((state) => state.supplier);
  const {
    pillarData,
    focusAreas,
    reportCreationYear,
    periodStartDate,
    periodEndDate,
    cdpDataAvailable,
    otherDataToReport,
  } = useSelector((state) => state.presurvey);

  const supplierName=sessionStorage.getItem('companyName');
  useEffect(() => {
    if (pillarData?.length) {
      setPillars(pillarData);
    }
  }, [pillarData]);

  useEffect(() => {
   
    if (form) {
      const startDate = periodStartDate ? dayjs(periodStartDate, "DD/MM/YYYY") : null;
      const endDate = periodEndDate ? dayjs(periodEndDate, "DD/MM/YYYY") : null;
console.log(supplierName);

      form.setFieldsValue({
        supplierName: supplierName || "" ,
        reportCreationYear: reportCreationYear || "",
        periodStartDate: startDate,
        periodEndDate: endDate,
        cdpDataAvailable: cdpDataAvailable || false,
        otherDataToReport: otherDataToReport || false,
        focusAreas: Object.keys(focusAreas).filter(
          (pillarId) => focusAreas[pillarId]
        )
      });
    }
  }, [
    form,
    supplierName,
    reportCreationYear,
    periodStartDate,
    periodEndDate,
    cdpDataAvailable,
    otherDataToReport,
    focusAreas,
  ]);

  const onChangeStart = (date) => {
    const formattedDate = date ? date.format("DD/MM/YYYY") : null;
    dispatch(setFormField({ field: "periodStartDate", value: formattedDate }));
    form.setFieldsValue({ periodStartDate: date });
    handleDateChange("periodStartDate")(date, formattedDate);
    setIsDraft(true);
    form.validateFields(["periodStartDate"]).catch((err) => {
      console.error("Validation failed:", err);
    });
  };
console.log(supplierName);

  const onChangeEnd = (date) => {
    const formattedDate = date ? date.format("DD/MM/YYYY") : null;
    dispatch(setFormField({ field: "periodEndDate", value: formattedDate }));
    form.setFieldsValue({ periodEndDate: date });
    handleDateChange("periodEndDate")(date, formattedDate);
    setIsDraft(true);
    form.validateFields(["periodEndDate"]).catch((err) => {
      console.error("Validation failed:", err);
    });
  };

  const handleCheckboxChange = (pillarId) => (e) => {
    const checked = e.target.checked;
    const updatedFocusAreas = {
      ...focusAreas,
      [pillarId]: checked,
    };
    dispatch(setFormField({ field: "focusAreas", value: updatedFocusAreas }));
    setIsDraft(true);
  };

  const handleToggleSwitchChange = (field) => (newValue) => {
    dispatch(setFormField({ field, value: newValue }));

    if (otherDataToReport == false) {
      dispatch(setFormField({ field: "focusAreas", value: {} }))
    }


    setIsDraft(true);
  };

  const validateFocusAreas = (_, value) => {
    const selectedFocusAreas = Object.keys(focusAreas).filter(
      (pillarId) => focusAreas[pillarId]
    );
    if (selectedFocusAreas.length === 0) {
      return Promise.reject(new Error(MESSAGES.VALIDATION.REQUIRED_FOCUS_AREA));
    }
    return Promise.resolve();
  };

  return (
    <Form form={form} layout="horizontal">
      <Row className="form-row" gutter={16}>
        <Col span={12} xs={24} sm={24} md={12} lg={12} xl={12}>
          <div className="form-item-content">
            <div className="form-item-label">
              <span style={{ color: "red" }}>*</span> {LABELS.SUPPLIER_NAME}
            </div>
            <div className="form-item-input">
              <Form.Item name="supplierName" className="form-item-custom">
                <Input
                  id="supplierNameInput"
                  data-testid="supplierNameInput"
                  aria-label={LABELS.SUPPLIER_NAME}
                  value={supplierName}
                  onChange={handleFieldChange("supplierName")}
                  disabled
                />
              </Form.Item>
            </div>
          </div>
        </Col>
        <Col span={12} xs={24} sm={24} md={12} lg={12} xl={12}>
          <div className="form-item-content">
            <div className="form-item-label">
              <span style={{ color: "red" }}>*</span> {LABELS.REPORT_CREATION_YEAR}
            </div>
            <div className="form-item-input">
              <Form.Item name="reportCreationYear" className="form-item-custom">
                <Input
                  id="reportCreationYearInput"
                  data-testid="reportCreationYearInput"
                  aria-label={LABELS.REPORT_CREATION_YEAR}
                  value={reportCreationYear}
                  onChange={handleFieldChange("reportCreationYear")}
                  disabled
                />
              </Form.Item>
            </div>
          </div>
        </Col>
      </Row>
      <Row className="form-row" gutter={16}>
        <Col span={12} xs={24} sm={24} md={12} lg={12} xl={12}>
          <div className="form-item-content">
            <div className="form-item-label">
              <span style={{ color: "red" }}>*</span> {LABELS.PERIOD_START_DATE}
            </div>
            <div className="form-item-input">
              <Form.Item
                name="periodStartDate"
                rules={[{ validator: (_, value) => validateStartDate(value) }]}
                className="form-item-custom"
              >
                <DatePicker
                  id="periodStartDatePicker"
                  data-testid="periodStartDatePicker"
                  format="DD/MM/YYYY"
                  onChange={onChangeStart}
                  disabledDate={disableDateRange}
                  allowClear
                />
              </Form.Item>
            </div>
          </div>
        </Col>
        <Col span={12} xs={24} sm={24} md={12} lg={12} xl={12}>
          <div className="form-item-content">
            <div className="form-item-label">
              <span style={{ color: "red" }}>*</span> {LABELS.PERIOD_END_DATE}
            </div>
            <div className="form-item-input">
              <Form.Item
                name="periodEndDate"
                rules={[
                  {
                    validator: (_, value) => {
                      const startDate = form.getFieldValue("periodStartDate");
                      return validateEndDate(startDate, value);
                    },
                  },
                ]}
                className="form-item-custom"
              >
                <DatePicker
                  id="periodEndDatePicker"
                  data-testid="periodEndDatePicker"
                  className="custom-datepicker"
                  format="DD/MM/YYYY"
                  onChange={onChangeEnd}
                  disabledDate={disableDateRange}
                />
              </Form.Item>
            </div>
          </div>
        </Col>
      </Row>
      <Row className="form-row" gutter={16}>
        <Col span={12} xs={24} sm={24} md={12} lg={12} xl={12}>
          <div className="form-item-content">
            <div className="form-item-label">
              <span style={{ color: "red" }}>*</span> {LABELS.CDP_DATA_AVAILABLE}
            </div>
            <div className="form-item-input">
              <Form.Item name="cdpDataAvailable" className="form-item-custom">
                <ToggleButton
                  id="cdpDataAvailableSwitch"
                  data-testid="cdpDataAvailableSwitch"
                  isToggled={cdpDataAvailable}
                  checkedChildren="Yes"
                  unCheckedChildren="No"
                  onToggle={handleToggleSwitchChange("cdpDataAvailable")}
                  aria-label={LABELS.CDP_DATA_AVAILABLE}
                />
              </Form.Item>
            </div>
          </div>
        </Col>
      </Row>

      <Row className="form-row" gutter={16}>
        <Col span={12} xs={24} sm={24} md={12} lg={12} xl={12}>
          <div className="form-item-content">
            <div className="form-item-label">
              <div className="label-container">
                <div className="required-symbol">
                  <span style={{ color: "red" }}>*</span>
                </div>
                <div className="label-text">
                  {LABELS.OTHER_DATA_TO_REPORT}
                </div>
              </div>
            </div>
            <div className="form-item-input">
              <Form.Item name="otherDataToReport" className="form-item-custom">
                <ToggleButton
                  id="otherDataToReportSwitch"
                  data-testid="otherDataToReportSwitch"
                  isToggled={otherDataToReport}
                  checkedChildren="Yes"
                  unCheckedChildren="No"
                  onToggle={handleToggleSwitchChange("otherDataToReport")}
                  aria-label={LABELS.OTHER_DATA_TO_REPORT}
                />
              </Form.Item>
            </div>
          </div>
        </Col>
      </Row> {

        otherDataToReport &&


        <Row className="form-row" gutter={16}>
          <Col span={24}>
            <div className="form-item-content">
              <div className="form-item-label">
                <span style={{ color: "red" }}>*</span> {LABELS.FOCUS_AREAS}
              </div>
              <div className="form-item-input">
                <Form.Item
                  name="focusAreas"
                  className="form-item-custom"
                  rules={[{ validator: validateFocusAreas }]}
                >
                  <Row gutter={16} justify="start">
                    <Col xs={24} sm={8} md={8} lg={8}>
                      <Checkbox
                        id="focusAreaCheckbox-Energy"
                        data-testid="focusAreaCheckbox-Energy"
                        checked={focusAreas.Energy || false}
                        onChange={handleCheckboxChange("Energy")}
                      >
                        {LABELS.ENERGY}
                      </Checkbox>
                    </Col>
                    <Col xs={24} sm={8} md={8} lg={8}>
                      <Checkbox
                        id="focusAreaCheckbox-Waste"
                        data-testid="focusAreaCheckbox-Waste"
                        checked={focusAreas.Waste || false}
                        onChange={handleCheckboxChange("Waste")}
                      >
                        {LABELS.WASTE}
                      </Checkbox>
                    </Col>
                    <Col xs={24} sm={8} md={8} lg={8}>
                      <Checkbox
                        id="focusAreaCheckbox-Packaging"
                        data-testid="focusAreaCheckbox-Packaging"
                        checked={focusAreas.Packaging || false}
                        onChange={handleCheckboxChange("Packaging")}
                      >
                        {LABELS.PACKAGING}
                      </Checkbox>
                    </Col>
                  </Row>
                </Form.Item>
              </div>
            </div>
          </Col>
        </Row>
      }

    </Form>
  );
};

export default PreSurvey;
